export const OrganizationTypes = {
  CUSTOMER: "customer",
  TEO: "teo",
  UTILITY: "utility"
}



// WEBPACK FOOTER //
// ./src/enums/OrganizationTypes.js